<template>
  <div>
    <LeftSidebar
      :visible="visible"
      baseClass="edit-user-wrapper"
      :title="$lang.roomEdit"
      :hasHeaderRightIcon="false"
    >
      <template>
        <div class="padding-y-16">
          <FormLoading :loading="getLoading" :count="8">
            <template>
              <div class="padding-x-16">
                <Input
                  :title="`${$lang.roomName} (${$lang.required})`"
                  :label="$lang.roomName"
                  :placeholder="$lang.roomName"
                  :value="form.name"
                  name="name"
                  id="name"
                  type="text"
                  :vuelidateObj="$v.form.name"
                  @input="input"
                  @focus="resetValidation"
                  @blur="checkValidation"
                />
                <Input
                  :title="$lang.roomLink"
                  :label="$lang.roomLink"
                  :placeholder="$lang.roomLink"
                  :value="form.link"
                  name="link"
                  id="link"
                  type="text"
                  :vuelidateObj="$v.form.link"
                  @input="input"
                  @focus="resetValidation"
                  @blur="checkValidation"
                />
                <Input
                  :title="$lang.capacity"
                  :label="$lang.capacity"
                  :placeholder="$lang.capacity"
                  :value="form.capacity"
                  name="capacity"
                  id="capacity"
                  type="text"
                  :vuelidateObj="$v.form.capacity"
                  @input="input"
                  @focus="resetValidation"
                  @blur="checkValidation"
                />
                <Input
                  :title="$lang.description"
                  :label="$lang.description"
                  :placeholder="$lang.description"
                  :value="form.description"
                  name="description"
                  id="description"
                  type="textarea"
                  :vuelidateObj="$v.form.description"
                  @input="input"
                  @focus="resetValidation"
                  @blur="checkValidation"
                />
              </div>
            </template>
          </FormLoading>
        </div>
      </template>
      <template #footer>
        <Button
          variant="filled-complementary"
          :text="$lang.cancel"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          @click="handleClose"
        />
        <Button
          v-if="checkPermission(permissions, ['admin', 'edit'])"
          variant="primary"
          :text="$lang.edit"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          :loading="loading"
          @click="handleSubmit"
        />
      </template>
    </LeftSidebar>
  </div>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import LeftSidebar from "@/components/re-design/sidebar/LeftSidebar.vue";
import { Input, Button, FormLoading } from "@/components/re-design/forms";
import { required, numeric } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { checkPermission, generateError, toastAlert } from "@/shared/utils";
import {
  getCenterExecuteRoom,
  updateCenterExecuteRoom,
} from "@/modules/kanoon/services";

export default {
  mixins: [inputMixin],
  inject: ["CENTER_EXECUTE_DATA", "handleReloadList"],
  components: {
    LeftSidebar,
    Input,
    Button,
    FormLoading,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    roomId: {
      type: [String, Number],
      default: null,
    },
  },
  validations() {
    return {
      form: {
        name: { required },
        link: {},
        capacity: { numeric },
        description: {},
      },
    };
  },
  data() {
    return {
      form: {
        name: null,
        link: null,
        capacity: null,
        description: null,
      },
      getLoading: false,
      loading: false,
      permissions: [],
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        if (value) {
          this.resetForm(); // read this method of input mixin for reset all input values of form object
          this.fetchData();
        }
      },
    },
  },
  methods: {
    pathOr,
    checkPermission,
    handleClose() {
      this.$emit("handleClose");
    },
    async fetchData() {
      try {
        this.getLoading = true;
        const centerExecuteId = pathOr(null, ["id"], this.CENTER_EXECUTE_DATA);
        const response = await getCenterExecuteRoom(
          centerExecuteId,
          this.roomId
        );
        const { name, link, capacity, description, permissions } = response;

        this.input("name", name);
        this.input("link", link);
        this.input("capacity", capacity);
        this.input("description", description);
        this.permissions = permissions;
      } catch (error) {
        generateError(error);
      } finally {
        this.getLoading = false;
      }
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.loading = true;
        const { name, link, capacity, description } = this.form;
        const centerExecuteId = pathOr(null, ["id"], this.CENTER_EXECUTE_DATA);
        const roomId = this.roomId;
        const response = await updateCenterExecuteRoom({
          centerExecuteId,
          roomId,
          name,
          link,
          capacity,
          description,
        });
        const { message } = response;
        toastAlert(message);
        this.handleClose();
        this.resetForm();
        this.permissions = [];
        this.handleReloadList();
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
